import { DocplannerDoctorAddressMappingQuery } from '@dreryk/egabinet-docplanner-frontend-api';
import { HealthcareProviderLocationIdentifier } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { performCqrsQueryExists } from '@dreryk/command-query-react-common';
import { TranslatableText } from '@dreryk/react-common';
import { Slot } from '@dreryk/watermelon';

import { docplannerTranslationKeys } from '../translations';

type LocationIdentifierAssociationWithDocplannerValidator = (
   locationIdentifier: HealthcareProviderLocationIdentifier
) => Promise<TranslatableText | undefined>;

export const useLocationAssociationWithDocplannerValidator = (): LocationIdentifierAssociationWithDocplannerValidator => {
   return async (locationIdentifier) => {
      const locationExists = await performCqrsQueryExists(() => {
         const query = new DocplannerDoctorAddressMappingQuery();
         query.locationIdentifier = Slot.of(locationIdentifier);
         return query;
      });
      if (locationExists) {
         return undefined;
      }
      return docplannerTranslationKeys.validations.serviceProvidingLocationIsNotAssociatedWithDocplanner;
   };
};
